import { useTranslation } from 'react-i18next';

import { Heading } from '@app/shared/ui/atoms/Common';

interface TopBarProps {
  translationKey?: string;
}

export function TopBar({ translationKey }: TopBarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex shrink-0 items-center gap-4 pb-3 pr-9">
      {translationKey && (
        <Heading level={4} className="flex-1 truncate text-center">
          {t(translationKey)}
        </Heading>
      )}
    </div>
  );
}
